import React, { useState } from 'react';
import axios from 'axios';
import { apiBaseUrl } from '../config.js';

const MercadoPagoPayment = ({ 
  title = "Tasación Inmobiliaria", 
  price, 
  description, 
  userEmail,
  smp,
  onPaymentSuccess,
  onPaymentError 
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [paymentOpened, setPaymentOpened] = useState(false);

  const createPayment = async () => {
    try {
      setLoading(true);
      setError('');

      
      const response = await axios.post(`${apiBaseUrl}/api/create_payment`, {
        title: title,
        price: price,
        description: description,
        userEmail: userEmail,
        smp: smp,
        currency: 'ARS'
      });

      if (response.data.success) {
        
        // Save payment information for post-payment processing
        const paymentInfo = {
          preferenceId: response.data.preferenceId,
          externalReference: response.data.externalReference,
          smp: smp,
          timestamp: Date.now(),
          pendingPayment: true
        };
        
        localStorage.setItem('pendingMercadoPagoPayment', JSON.stringify(paymentInfo));
        localStorage.setItem('lastAnalyzedSmp', smp); // Ensure SMP is saved
        
        // Redirect to MercadoPago checkout
        window.open(response.data.initPoint, '_blank');
        
        // Show message that payment opened in new tab
        setPaymentOpened(true);
        
        // Don't call onPaymentSuccess here - only call it when payment is actually completed
        // The success will be handled by the payment success URL redirect
      } else {
        throw new Error('Failed to create payment preference');
      }

    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Error creating payment';
      setError(errorMessage);
      
      if (onPaymentError) {
        onPaymentError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      border: '2px solid #00b4d8',
      borderRadius: '12px',
      padding: '20px',
      backgroundColor: '#f8f9ff',
      margin: '20px 0'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: '15px'
      }}>
        <img 
          src="https://http2.mlstatic.com/storage/logos-api-admin/51b446b0-571c-11e8-9a2d-4b2bd7b1bf77-m.svg" 
          alt="MercadoPago" 
          style={{ height: '24px', marginRight: '12px' }}
        />
        <span style={{ 
          fontSize: '18px', 
          fontWeight: 'bold', 
          color: '#2c3e50' 
        }}>
          Pagar con MercadoPago
        </span>
      </div>

      <div style={{
        backgroundColor: 'white',
        padding: '15px',
        borderRadius: '8px',
        marginBottom: '15px',
        border: '1px solid #e9ecef'
      }}>
        <div style={{ 
          fontSize: '16px', 
          fontWeight: '600', 
          color: '#2c3e50',
          marginBottom: '8px'
        }}>
          {title}
        </div>
        {description && (
          <div style={{ 
            fontSize: '14px', 
            color: '#6c757d',
            marginBottom: '8px'
          }}>
            {description}
          </div>
        )}
        <div style={{ 
          fontSize: '20px', 
          fontWeight: 'bold', 
          color: '#28a745'
        }}>
          ${price?.toLocaleString('es-AR')} ARS
        </div>
      </div>

      {error && (
        <div style={{
          backgroundColor: '#ffe6e6',
          color: '#d8000c',
          padding: '12px',
          borderRadius: '6px',
          marginBottom: '15px',
          fontSize: '14px'
        }}>
          ❌ {error}
        </div>
      )}

      {paymentOpened && (
        <div style={{
          backgroundColor: '#e6f7ff',
          color: '#0066cc',
          padding: '12px',
          borderRadius: '6px',
          marginBottom: '15px',
          fontSize: '14px',
          textAlign: 'center'
        }}>
          💳 <strong>Pago abierto en nueva pestaña</strong><br/>
          Completa el pago y vuelve a esta página para ver tus resultados.
        </div>
      )}

      <button
        onClick={createPayment}
        disabled={loading || !price}
        style={{
          width: '100%',
          padding: '15px',
          fontSize: '16px',
          fontWeight: 'bold',
          color: 'white',
          backgroundColor: loading ? '#6c757d' : '#00b4d8',
          border: 'none',
          borderRadius: '8px',
          cursor: loading ? 'not-allowed' : 'pointer',
          transition: 'all 0.3s ease',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px'
        }}
        onMouseEnter={(e) => {
          if (!loading && price) {
            e.target.style.backgroundColor = '#0091ad';
          }
        }}
        onMouseLeave={(e) => {
          if (!loading && price) {
            e.target.style.backgroundColor = '#00b4d8';
          }
        }}
      >
        {loading ? (
          <>
            <div style={{
              width: '16px',
              height: '16px',
              border: '2px solid #ffffff',
              borderTop: '2px solid transparent',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}></div>
            Procesando...
          </>
        ) : (
          <>
            💳 Pagar Ahora
          </>
        )}
      </button>

      <div style={{
        fontSize: '12px',
        color: '#6c757d',
        textAlign: 'center',
        marginTop: '10px',
        lineHeight: '1.4'
      }}>
        🔒 Pago seguro con MercadoPago<br/>
        Aceptamos tarjetas de crédito, débito y transferencias
      </div>

      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default MercadoPagoPayment;
